import { KeySquare } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusIgnition({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const ignitionUpdateLog = device?.IgnitionUpdateLog;
  const lockEngaged = ignitionUpdateLog?.ignitionOn && ignitionUpdateLog?.locked;

  return (
    <ViewMgtDevicePanel title="Ignition" icon={<KeySquare size={16} />}>
      <div className="grid grid-cols-1 gap-0">
        
        <ViewMgtDeviceStatusValue
          label="Status"
          timestamp={ignitionUpdateLog?.logTimestamp}
          value={ignitionUpdateLog?.ignitionOn ? "On" : "Off" }
          color={ignitionUpdateLog?.ignitionOn ? "text-blue-500" : "text-state-500" }
          />

        <ViewMgtDeviceStatusValue
          label="Lock"
          value={lockEngaged ? "Engaged" : "-" }
          color={lockEngaged ? "text-red-500" : "text-state-500"}
          timestamp={lockEngaged ? ignitionUpdateLog?.logTimestamp : "-"}
          />

      </div>
    </ViewMgtDevicePanel>
  );
}
